import { type PipelineEditorGraphInputStep } from '../../types.ts'

export class Cycles {
  hasPath(
    graph: {
      [p: string]: PipelineEditorGraphInputStep
    },
    start: string,
    target: string,
    visited: Set<string>
  ) {
    if (start === target) return true
    visited.add(start)

    const startNode = graph[start]
    const targetNode = graph[target]
    if (!startNode || !targetNode) return false

    const childNodes = startNode?.step?.nextStepsRule?.possibleNextSteps ?? []
    for (const nextNodeId of childNodes) {
      // Check if we have a path from the next node to the target
      if (!visited.has(nextNodeId) && this.hasPath(graph, nextNodeId, target, visited)) {
        return true
      }
    }
    return false
  }

  addEdge(
    graph:
      | {
          [p: string]: PipelineEditorGraphInputStep
        }
      | undefined,
    u: string,
    v: string
  ) {
    if (!graph) return true
    const visited = new Set<string>()

    if (u === v) return false

    // Check if there is a reverse path, if so there is a cycle
    return !this.hasPath(graph, v, u, visited)
  }
}
